__turbopack_context__.v({
  "alignCenter": "LayoutCluster-module__4imsHq__alignCenter",
  "alignEnd": "LayoutCluster-module__4imsHq__alignEnd",
  "alignStart": "LayoutCluster-module__4imsHq__alignStart",
  "cluster": "LayoutCluster-module__4imsHq__cluster",
  "clustered": "LayoutCluster-module__4imsHq__clustered",
  "container": "LayoutCluster-module__4imsHq__container",
  "flex": "LayoutCluster-module__4imsHq__flex",
  "justified": "LayoutCluster-module__4imsHq__justified",
  "justifyCenter": "LayoutCluster-module__4imsHq__justifyCenter",
  "justifyEnd": "LayoutCluster-module__4imsHq__justifyEnd",
  "justifySpaceAround": "LayoutCluster-module__4imsHq__justifySpaceAround",
  "justifySpaceBetween": "LayoutCluster-module__4imsHq__justifySpaceBetween",
  "justifyStart": "LayoutCluster-module__4imsHq__justifyStart",
  "noWrap": "LayoutCluster-module__4imsHq__noWrap",
});
